import React from 'react';
import { usePricingFigures, usd } from '../../../hooks/usePricingFigures';
const head = 'text-[11.5px] font-bold uppercase tracking-[0.12em] text-[#c5cdd3] whitespace-nowrap';

/** Option C: a short list of our fees, ad spend set apart, hires beside it. */
export function PricingFeeList({
  includeLeader
}: {
  includeLeader: boolean;
}) {
  const f = usePricingFigures(includeLeader);
  const fees = [...(f.showImplementation ? [{
    label: 'Implementation',
    sub: f.implementationNote,
    value: usd(f.implementation),
    deadline: f.promoDeadlineText
  }] : []), {
    label: 'Monthly service',
    sub: f.monthlyNote,
    value: `${usd(f.monthly)} / mo`,
    deadline: null
  }, {
    label: 'Placement bonus',
    sub: f.bonusNote,
    value: `${usd(f.bonus)} / rep`,
    deadline: null,
    accent: true
  }, ...(f.retentionBonus > 0 ? [{
    label: 'Day-45 bonus',
    sub: f.retentionNote,
    value: `${usd(f.retentionBonus)} / rep`,
    deadline: null,
    accent: true
  }] : [])];
  return <div className="grid grid-cols-[1.75fr_1fr] gap-8 items-center" data-id="element-832" data-mp="38gvomxlsab4e">
      <div data-id="element-833" data-mp="2tjct9celoznz">
        <div className={head} data-id="element-834" data-mp="2tjl7p8qdgd1a">Paid to D2D HIRE</div>
        <ul className="mt-1.5" data-id="element-835" data-mp="2yj7hf86zrb5c">
          {fees.map(fee => <li key={fee.label} className="flex items-baseline justify-between gap-4 py-[6px] border-b border-[#222d35]" data-id="element-836" data-mp="2yhmqrtnssccr">
              <div className="min-w-0" data-id="element-837" data-mp="2pjuhp78o60xt">
                <span className={`text-[15px] font-semibold ${fee.accent ? 'text-[#6fd6b0]' : 'text-white'}`} data-id="element-838" data-mp="2pkvvvkkzf3jr">
                  {fee.label}
                </span>
                <span className="ml-2 text-[12.5px] text-[#8e9aa4]" data-id="element-839" data-mp="2fqvkj0z3x22l">{fee.sub}</span>
                {fee.deadline && <span className="ml-2 text-[13px] font-bold text-[#6fd6b0]" data-id="element-840" data-mp="25usehk14wjad">
                    {fee.deadline}
                  </span>}
              </div>
              <span className={`shrink-0 text-[16px] font-bold ${fee.accent ? 'text-[#6fd6b0]' : 'text-white'}`} data-id="element-841" data-mp="ce617ffkddbh">
                {fee.value}
              </span>
            </li>)}
        </ul>
        <div className="mt-2 flex items-baseline justify-between gap-4 rounded-md bg-[#1a232a] px-3 py-[6px]" data-id="element-842" data-mp="3tsuj8t1zvapi">
          <div className="min-w-0" data-id="element-843" data-mp="vb75sz57hbew">
            <span className="text-[15px] font-semibold text-[#c5cdd3]" data-id="element-844" data-mp="va5uquo6wox6">
              Recommended ad spend
            </span>
            <span className="ml-2 text-[12.5px] text-[#8e9aa4]" data-id="element-845" data-mp="qa1e94na7u6y">
              {f.adsNote}, not to D2D HIRE
            </span>
          </div>
          <span className="shrink-0 text-[16px] font-bold text-[#c5cdd3]" data-id="element-846" data-mp="ha4hsgunhr1c">
            {usd(f.adSpend)} / mo
          </span>
        </div>
      </div>
      <div className="border-l border-[#33404a] pl-7" data-id="element-847" data-mp="360njrl0z2nlv">
        <div className={head} data-id="element-848" data-mp="320c3sljk1bgq">Projected hires / mo</div>
        <div className="brief-display mt-1 text-[56px] font-extrabold leading-none text-[#6fd6b0]" data-id="element-849" data-mp="1hjcnmqjokp53">
          {f.hiresLow}–{f.hiresHigh}
        </div>
        <div className="mt-1.5 text-[12.5px] leading-snug text-[#aab4bc]" data-id="element-850" data-mp="1llr5p8fizkvb">
          {usd(f.costLow)}–{usd(f.costHigh)} all-in per hire, incl. est. bonuses
        </div>
      </div>
    </div>;
}